import React, { useState, useRef } from 'react';
import Brightness5Icon from '@mui/icons-material/Brightness5'; // Sun icon
import NightsStayIcon from '@mui/icons-material/NightsStay'; // Moon icon
import { IconButton } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import CancelIcon from '@mui/icons-material/Cancel';

export default ({title,toggleDrawer,children,HideCancelBtn}) => {

return(
    /* const [darkMode, setDarkMode] = useState(false);   
    const toggleDarkMode = () => {
      setDarkMode(prevMode => !prevMode);
      document.body.classList.toggle('dark-mode');
    }; */

    <>
    <h6 className='text-center py-2 text-theme-accent flex-center justify-content-between ps-3 pe-2 bg-theme-accent-1 border-bottom border-theme-accent-verylight'>
        <span>{title}</span>
        {/* <span id="day-night">
            <IconButton onClick={toggleDarkMode} aria-label="Toggle Dark Mode">
            {darkMode ? <DarkModeIcon /> : <LightModeIcon />}</IconButton>
        </span>  */}   
        {!HideCancelBtn ?
        <CancelIcon onClick={toggleDrawer()} className='svg-theme-secondary hover-svg-theme-accent' style={{ fontSize: '34px' }}/>
        :''}
        </h6>
        {children}
        </>

);
};